import { Component, EventEmitter, inject, OnInit, Output } from '@angular/core';
import { ProducerService } from '../../../core/data/services/producer.service';
import BaseListComponent from '../base-list/base-list.component';
import ProducerClientDto from '../../../core/data/dtos/producer-client.dto';
import PaginationFilter from '../../interfaces/table/paginationFilter';
import { AuthService } from '../../../features/auth/services/auth.service';
import { TableComponent } from '../table/table.component';
import TableHeader from '../../interfaces/table/tableHeader';
import { of } from 'rxjs';

@Component({
    selector: 'app-client-selector',
    providers: [ProducerService],
    templateUrl: './client-selector.component.html',
    styleUrl: './client-selector.component.css',
    imports: [TableComponent]
})
export class ClientSelectorComponent extends BaseListComponent<ProducerClientDto> {
  @Output() selectedClient = new EventEmitter<ProducerClientDto>();

  tableHeaders: TableHeader[] = [
    {
      label: 'Nombre',
      attribute: 'name',
    },
    {
      label: 'ID',
      attribute: 'idnumber',
    },
    {
      label: 'Teléfono',
      attribute: 'phone',
    },
    {
      label: 'Correo',
      attribute: 'emailAddress',
    },
  ];
  private readonly producerService = inject(ProducerService);
  private readonly authService = inject(AuthService);

  override request = (paginationFilter?: PaginationFilter) => {
    return this.producerService.getClients(
      this.authService.user.idTokenClaims!.extension_ProducerNumber!,
      paginationFilter,
    );
  };

  selectClient(client: ProducerClientDto) {
    this.selectedClient.emit(client);
  }
}
